module.exports = __webpack_public_path__ + "img/calming-influence.0fe28f2b.svg";